export default __webpack_public_path__ + "static/media/registration-form-template.fc39c6ab.jpg";